import { isAdmin } from '@spx-portal/shared-utils';
import * as React from 'react';

import { $gt } from '@/common/appCtx';
import { VueCtxStore } from '@/common/appCtx';
import { usePermissions } from '@/pages/shift/hooks/use-permissions';

import EnableShiftList from './enable-shift-list';
import MgmtList from './mgmt-list';

const List = () => {
  const permission = usePermissions();
  const showMgmtList = isAdmin();

  React.useLayoutEffect(() => {
    const breadcrumb = [
      { link: undefined, title: $gt('Workforce Management') },
      { link: undefined, title: $gt('Roster Planning') },
      { link: '/workforceops/roster-planning/shift/list', title: $gt('Shift Management') },
    ];
    VueCtxStore.dispatch('sharedBreadcrumb/updateBreadcrumb', breadcrumb);
  }, [showMgmtList]);

  if (!permission.hasViewPermission) {
    return null;
  }
  return (
    <>
      {showMgmtList ? <MgmtList /> : <EnableShiftList />}
    </>
  );
};

export default List;
